<script>
import appConfig from "@/app.config";
import {lichCongTacModel} from "@/models/lichCongTacModel";
import {CONSTANTS} from "@/helpers/constants";
import DatePicker from "vue2-datepicker";
import moment from "moment";
import Multiselect from "vue-multiselect";
import {CURRENT_USER} from "@/helpers/currentUser";
import ListFile from "@/pages/hopThu/listFile";

export default {
  page: {
    title: "Danh sách lịch công tác",
    meta: [{name: "description", content: appConfig.description}],
  },
  components: { DatePicker, Multiselect, ListFile},
  data() {
    return {
      title: "Danh sách lịch công tác",
      items: [
        {
          text: "Lịch công tác",
          href: "/danh-sach-lich-cong-tac",
          // active: true,
        },
        {
          text: "Danh sách",
          active: true,
        }
      ],
      model: lichCongTacModel.baseJson(),
      selectDay: moment().format("DD/MM/YYYY"),
      fields: [
        {key: 'STT', label: 'STT', class: 'text-center', sortable: false, thClass: 'hidden-sortable', thStyle: {width: '50px', minWidth: '50px'},},
        {
          key: "chuTri",
          label: "Người chủ trì",
          class: "px-2",
          sortable: true,
          thStyle: {width: '100px', minWidth: '100px'},
        },
        {
          key: "thoiGian",
          label: "Thời gian",
          thClass: 'hidden-sortable',
          thStyle: {width: '100px', minWidth: '100px'},
          sortable: false,
        },
        {
          key: 'noiDung',
          label: "Nội dung",
          thClass: 'hidden-sortable',
          sortable: false,
          class: "text-center"
        },
        {
          key: 'diaDiem',
          label: "Địa điểm",
          thClass: 'hidden-sortable',
          sortable: false,
          thStyle: {width: '100px', minWidth: '100px'},
          class: "text-center"
        },
        {
          key: 'thanhPhan',
          label: "Thành phần",
          thClass: 'hidden-sortable',
          sortable: false,
          class: "text-center"
        },
        {
          key: 'ghiChu',
          label: "Ghi chú",
          thClass: 'hidden-sortable',
          sortable: false,
          thStyle: {width: '100px', minWidth: '100px'},
          class: "text-center"
        },
      ],
      loaiLichCongTac: this.$route.params.loaiLichCongTac,
      lang: {
        formatLocale: {
          firstDayOfWeek: 1,
        },
        monthBeforeYear: false,
      },
      isCollapse: false,
      itemFilter: {
        ngayBatDau: null,
        ngayKetThuc: null,
        nguoiChuTri: null,
        congViec: null,
        selectDay: moment().format("DD/MM/YYYY"),
      },
      showListFile: false,
      listFiles: [],
      currentUserName: CURRENT_USER.USERNAME,
      optionsUser: [],
      showModalChiTietLCT: false,
      chiTietCongViec: null,
    };
  },
  created() {
    this.getUser();
    this.myProvider();
  },
  watch: {
    model: {
      deep: true,
      handler(val) {
        // addCoQuanToModel()
        // this.saveValueToLocalStorage()
      },
    },
    '$route.params.loaiLichCongTac':{
      deep: true,
      handler(val) {
        this.loaiLichCongTac = val;
        if(val == 'lctt'){
          this.title = "Lịch công tác trường"
        }else if(val == 'lctdv'){
          this.title = "Lịch công tác đơn vị"
        }else{
          this.title = "Lịch công tác cá nhân"
        }
        this.myProvider();
      }
    },
    itemFilter: {
      deep: true,
      handler(val) {
        this.myProvider();
      }
    },
  },
  methods: {
    showChiTietLCT(cv) {
      this.showModalChiTietLCT = true
      this.chiTietCongViec = cv;
    },
    async getUser() {
      try {
        await this.$store.dispatch("userStore/getAll").then(resp => {
          if (resp.resultCode == "SUCCESS") {
            let items = resp.data
            this.loading = false
            this.optionsUser = items;
          }
          return [];
        });
      } finally {
        this.loading = false
      }
    },
    myProvider(ctx) {
      try {
        this.$store.dispatch("lichCongTacStore/getPaging",{loaiLichCongTac: this.loaiLichCongTac, selectDay: this.itemFilter.selectDay, nguoiChuTri: this.itemFilter.nguoiChuTri, congViec: this.itemFilter.congViec } ).then(resp => {
          if (resp.resultCode == CONSTANTS.SUCCESS) {
            let data = resp.data;
            this.model = resp.data;
            this.loading = false
          } else {
            return [];
          }
        })
      } finally {
        this.loading = false
      }
    },
    handleTimKiem(){
     this.myProvider();
    },
    clearSearch(){
      this.itemFilter.ngayBatDau = null;
      this.itemFilter.ngayKetThuc = null;
      this.itemFilter.nguoiChuTri= null;
      this.itemFilter.congViec = null;
    },
    checkThanhPhanLichCongTac(item) {
      if (item) {
        if (item.chuTri && item.chuTri.length > 0) {
          let check = item.chuTri.find(x => x.userName == this.currentUserName);
          if (check)
            return true;
        }
        if (item.thanhPhanThamDu && item.thanhPhanThamDu.length > 0) {
          let check = item.thanhPhanThamDu.find(x => x.userName == this.currentUserName);
          if (check)
            return true;
        }
      }
      return false;
    },
    handleShowListFile(files) {
      this.showListFile = true;
      this.listFiles = files;
    },
  }
}
</script>
<template>
  <div>
    <div class="row">
      <div class="col-12">
        <div class="card mb-2">
          <div class="card-body">
            <div class="row">
              <div class="col-md-4 col-12 d-flex align-items-center">
                <h4 class="font-size-18 fw-bold text-dark">Lịch công tác</h4>
              </div>
              <div class="col-md-8 col-12 text-end">
                <b-button v-b-toggle.collapseSearch variant="light"
                          class="btn w-md btn-primary-outline me-2" size="sm">
                  <i class="fas fa-caret-down align-middle me-2"></i>
                  Tìm kiếm
                </b-button>
              </div>
            </div>
            <b-collapse id="collapseSearch" class="mt-1">
              <div class="row">
                <div class="col-12">
                  <div class="d-flex justify-content-between align-items-end flex-wrap mb-2">
                    <!-- Ngày tạo -->
                    <div class="flex-grow-1 me-2">
                      <label class="mb-1">Ngày công tác</label>
                      <div class="d-flex justify-content-between align-items-center flex-wrap">
                        <div class="flex-grow-1 me-2 mb-md-0 mb-2">
                          <date-picker v-model="itemFilter.selectDay"
                                       format="DD/MM/YYYY"
                                       value-type="format"
                          >
                            <div slot="input">
                              <input v-model="itemFilter.selectDay"
                                     v-mask="'##/##/####'" type="text" class="form-control"
                                     placeholder="Nhập ngày bắt đầu"/>
                            </div>
                          </date-picker>
                        </div>
<!--                        <div class="flex-grow-1 me-2 mb-md-0 mb-2">-->
<!--                          <date-picker v-model="itemFilter.ngayKetThuc"-->
<!--                                       format="DD/MM/YYYY"-->
<!--                                       value-type="format"-->
<!--                          >-->
<!--                            <div slot="input">-->
<!--                              <input v-model="itemFilter.ngayKetThuc"-->
<!--                                     v-mask="'##/##/####'" type="text" class="form-control"-->
<!--                                     placeholder="Nhập ngày kết thúc"/>-->
<!--                            </div>-->
<!--                          </date-picker>-->
<!--                        </div>-->
                      </div>
                    </div>
                    <!-- Người chủ trì -->
                    <div class="flex-grow-1 me-2">
                      <label class="mb-1">Người chủ trì</label>
                      <multiselect v-model="itemFilter.nguoiChuTri" :options="optionsUser" track-by="id" label="fullName"
                                   placeholder="Chọn người tạo" deselect-label="Nhấn để xoá"
                                   selectLabel="Nhấn enter để chọn"
                                   selectedLabel="Đã chọn"></multiselect>
                    </div>
                    <!-- Công việc -->
                    <div class="flex-grow-1">
                      <label class="mb-1">Công việc</label>
                      <input size="sm" type="text" name="untyped-input" class="form-control"
                             v-model="itemFilter.congViec"
                             placeholder="Nhập công việc"/>
                    </div>
                    <!--  Xử lý -->
<!--                    <div class="flex-grow-0 ms-2">-->
<!--                      <div class="d-flex justify-content-between align-items-center flex-wrap">-->
<!--                        <div class="flex-grow-1 mt-xl-0 mt-2">-->
<!--                          <b-button @click="handleSearch" variant="light"-->
<!--                                    class="btn w-md btn-primary me-2" size="md">-->
<!--                            <i class="fas fa-search align-middle me-2"></i>-->
<!--                            Tìm kiếm-->
<!--                          </b-button>-->
<!--                        </div>-->
<!--                        <div class="flex-grow-1 mt-xl-0 mt-2">-->
<!--                          <b-button @click="clearSearch" variant="light"-->
<!--                                    class="btn w-md btn-secondary me-2" size="md">-->
<!--                            <i class="fas fa-redo-alt align-middle me-2"></i>-->
<!--                            Làm mới-->
<!--                          </b-button>-->
<!--                        </div>-->
<!--                      </div>-->
<!--                    </div>-->
                  </div>
                </div>
              </div>
            </b-collapse>
          </div>
        </div>
      </div>
    </div>
<!--    <section>-->
<!--      <div class="card">-->
<!--        <div class="card-body">-->
<!--          <div class="row" style="display: flex;align-items: center">-->
<!--            <div class="col-md-4">-->
<!--              <date-picker-->
<!--                  v-model="selectDay"-->
<!--                  :lang="lang"-->
<!--                  format="DD/MM/YYYY"-->
<!--                  placeholder="Chọn ngày"-->
<!--                  :value="selectDay"-->
<!--              ></date-picker>-->
<!--            </div>-->
<!--            <div class="col-md-4">-->
<!--              <b-button-->
<!--                  variant="primary"-->
<!--                  type="button"-->
<!--                  class="btn w-md btn-primary"-->
<!--                  @click="handleTimKiem"-->
<!--                  size="sm"-->
<!--              >-->
<!--                <i class="mdi mdi-plus me-1"></i> Tìm kiếm-->
<!--              </b-button>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
<!--    </section>-->

    <!--    Danh sach lic cong tac -->
    <section>
      <div v-if="model && model.length > 0">
        <div v-for="(item, index) in model" :key="index">
          <b-card style="padding: 0" class="card-lichcongtac mb-2">

            <b-card-header v-if="item"
                           class="fw-bold text-white bg-primary"
                           style="display: flex; justify-content: space-between"
            >
              <div >
                <i class="fas fa-calendar-alt me-1"></i>
                {{ item.ngayXepLich }}
              </div>

              <button
                  v-b-toggle="'collapse-'+index"
                  @click="isCollapse =!isCollapse"
                  type="button"
                  size="sm"
                  class="btn btn-outline btn-sm"
                  data-toggle="tooltip" data-placement="bottom" title="Xem chi tiết lịch">

                <i v-if="isCollapse" class="fas fa-chevron-up text-white me-1"></i>
                <i v-else class="fas fa-chevron-down text-white me-1"></i>
              </button>
            </b-card-header>
            <b-collapse visible :id="'collapse-' +index" accordion="my-accordion" role="tabpanel">
              <!--              Table -->
              <table style="margin: 0px" class="table table-bordered">
                <thead>
                <tr>
                  <th width="15%" class="title-capso">Người chủ trì</th>
                  <th class="text-center title-capso" width="100px">Thời gian</th>
                  <th  class="title-capso">Nội dung</th>
                  <th  class="title-capso" width="20%">Địa điểm</th>
                  <th class="title-capso"  width="20%">Thành phần</th>
                  <th  class="title-capso" width="10%">Ghi chú</th>
                  <th class="title-capso" width="10%">Tệp tin</th>
                </tr>
                </thead>
                <tbody v-if="item">
                <tr
                    v-for="(cv, index) in item.congViecs"
                    :key="index"
                >
                  <td v-if="cv.rowSpan > 0" :rowspan="`${cv.rowSpan}`" style="vertical-align : middle;text-align:left;" class="px-1">
                    <div  v-for="(value, index) in cv.chuTri" :key="index">
                      {{value.fullName}}
                    </div>
                  </td>
                  <td class="text-center" style="vertical-align : middle;text-align:left;" >
                    <div  v-if="cv.tuNgay && cv.denNgay">
                      {{cv.tuNgay}} - {{cv.denNgay}}
                    </div>
                    <div v-else-if="cv.thoiGian">
                      {{cv.thoiGian}}
                    </div>
                    <div v-else>
                      {{cv.tuNgay}}
                    </div>
                  </td>
                  <td class="px-1" style="vertical-align : middle;text-align:left;" >
                    <div v-if="cv.noiDung">
                      <a class="cs-cursor" @click="showChiTietLCT(cv)" :inner-html.prop="cv.noiDung"></a>
                    </div>
                    <div v-if="cv.noiDung" class="text-end">
                      <a @click="showChiTietLCT(cv)" class="badge badge-soft-info cs-cursor"><i class="fas fa-eye"></i>
                        Xem chi tiết
                      </a>
                    </div>
                  </td>
                  <td class="px-2" style="vertical-align : middle;text-align:left;" >
                    <div v-if="cv.diaDiem" :inner-html.prop="cv.diaDiem" >
                    </div>
                  </td>
                  <td class="px-1" style="vertical-align : middle;text-align:left;" >
                    <div v-if="cv.thanhPhanThamDu" >
                      <div class="title-capso">Thành phần tham dự:</div>
                      <span  v-for="(value, index) in cv.thanhPhanThamDu" :key="index">
                    <span>
                        {{value.fullName}},
                    </span>
                  </span>
                    </div>
                    <div v-if="cv.thanhPhan">
                      <div class="title-capso">Thành phần khác:</div>
                      <div v-if="cv.thanhPhan" :inner-html.prop="cv.thanhPhan" >
                      </div>
                    </div>

                  </td>
                  <td style="vertical-align : middle;text-align:left;" >
                    <div v-if="cv.ghiChu" :inner-html.prop="cv.ghiChu">
                    </div>
                  </td>
                  <td style="vertical-align : middle;text-align:center;">
                    <div v-if="checkThanhPhanLichCongTac(cv) && cv.files && cv.files.length > 0">
                      <a href="javascript:void(0)" @click="handleShowListFile(cv.files)">
                        <i class="fas fa-cloud-download-alt"></i>
                      </a>
                    </div>
                  </td>
                </tr>
                </tbody>
              </table>
            </b-collapse>
          </b-card>
        </div>
      </div>
      <div v-else>
        <b-alert variant="danger" class="mb-0" show>
          <strong><i class="mdi mdi-close-circle"></i></strong> Không có lịch công tác trong thời gian này.
        </b-alert>
      </div>

    </section>
    <!--    List files-->
    <ListFile :show-modal.sync="showListFile" :files.sync="listFiles"></ListFile>

    <b-modal
        v-model="showModalChiTietLCT"
        centered
        title="Chi tiết công việc"
        title-class="font-18"
        no-close-on-backdrop
        size="xl"
        hide-header
        hide-footer
        modal-class="cs-modal-chitietLCT"
    >
      <div class="row">
        <div class="col-12 position-relative">
          <a class="cs-close-modal" @click="showModalChiTietLCT = false"><i class="mdi mdi-close-thick"></i></a>
        </div>
      </div>
      <div class="row px-3 mt-3" v-if="chiTietCongViec">
        <div class="col-xl-7 col-lg-12 col-md-12 border-right">
          <div>
            <div>
              <h5 class="text-bold text-black">Nội dung</h5>
            </div>
            <h3 v-if="chiTietCongViec.noiDung" class="text-black" :inner-html.prop="chiTietCongViec.noiDung"></h3>
          </div>
          <div class="row cs-table-chitietLCT px-3">
            <div class="col-lg-6 col-md-12 mb-2">
              <div v-if="chiTietCongViec.diaDiem" class="d-flex align-items-start">
                <div>
                  <i class="mdi mdi-map-marker me-1 mdi-24px cs-icon"></i>
                </div>
                <div class="">
                  <p class="mb-1 cs-title">Địa điểm</p>
                  <p class="cs-content" :inner-html.prop="chiTietCongViec.diaDiem"></p>
                </div>
              </div>
            </div>
            <div class="col-lg-6 col-md-12 mb-2">
              <div v-if="chiTietCongViec.thoiGian" class="d-flex align-items-start">
                <div>
                  <i class="mdi mdi-timer me-1 mdi-24px cs-icon"></i>
                </div>
                <div class="">
                  <p class="mb-1 cs-title">Thời gian</p>
                  <p class="cs-content">{{ chiTietCongViec.thoiGian }}</p>
                </div>
              </div>
            </div>
            <div class="col-lg-6 col-md-12 mb-2">
              <div v-if="chiTietCongViec.tuNgay" class="d-flex align-items-start">
                <div>
                  <i class="mdi mdi-calendar-arrow-right me-1 mdi-24px cs-icon"></i>
                </div>
                <div class="">
                  <p class="mb-1 cs-title">Từ ngày</p>
                  <p class="cs-content">{{ chiTietCongViec.tuNgay }}</p>
                </div>
              </div>
            </div>
            <div class="col-lg-6 col-md-12 mb-2">
              <div v-if="chiTietCongViec.denNgay" class="d-flex align-items-start">
                <div>
                  <i class="mdi mdi-calendar-arrow-left me-1 mdi-24px cs-icon"></i>
                </div>
                <div class="">
                  <p class="mb-1 cs-title">Đến ngày</p>
                  <p class="cs-content">{{ chiTietCongViec.denNgay }}</p>
                </div>
              </div>
            </div>
          </div>
          <div v-if="chiTietCongViec.ghiChu" class="row mt-3">
            <div class="col-12">
              <div>
                <h5 class="text-bold text-black mb-2">Ghi chú:</h5>
                <p :inner-html.prop="chiTietCongViec.ghiChu"></p>
              </div>
            </div>
          </div>
          <div v-if="chiTietCongViec.files && chiTietCongViec.files.length > 0" class="row mt-3">
            <div class="col-12">
              <div>
                <h5 class="text-bold text-black mb-2">Văn bản đính kèm:</h5>
                <div>
                  <div
                      v-for="(value, index) in chiTietCongViec.files" :key="index"
                      class="px-2"
                      style="background-color: rgba(47,147,224,0.2); border-radius: 3px; padding: 5px; margin-bottom: 5px"
                  >
                    <a
                        :href="`${apiUrl}files/view/${value.fileId}`"
                        class=" fw-medium"
                    ><i
                        class="fas fa-cloud-download-alt"
                    ></i>
                      [Tải về]</a
                    >
                    <span style="padding-left: 20px; font-weight: 500; color: #2F93E0">{{ value.fileName }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-xl-5 col-lg-12 col-md-12 px-4">
          <!-- Thành phần chủ trì-->
          <div class="row mb-3">
            <div v-if="chiTietCongViec.chuTri" class="col-12">
              <div>
                <h5 class="text-bold text-black">Người chủ trì</h5>
              </div>
              <div v-if="chiTietCongViec.chuTri">
                <div v-for="(chutri, index) in chiTietCongViec.chuTri" :key="index" class="cs-row">
                  <div class="row equal-height-row">
                    <div class="col-md-6 col-12">
                      <div class="row equal-height-row">
                        <div class="col-3 justify-content-center">
                        <span v-if="chutri.avatar">
                          <b-img
                              :src=" url + `${chutri.avatar.fileId}`"
                              alt="Avatar"
                              class="rounded-circle header-profile-user"
                          >
                          </b-img>
                        </span>
                          <span v-else>
                            <img
                                class="rounded-circle header-profile-user"
                                src="@/assets/images/users/user-4.jpg"
                                alt="Avatar"
                            />
                          </span>
                        </div>
                        <div class="col-9 justify-content-center">
                          <p v-if="chutri.fullName" class="mb-0 text-black">{{ chutri.fullName }}</p>
                          <div v-if="chutri.email" class="d-flex align-items-center">
                            <i class="mdi mdi-email text-warning me-1"></i>
                            <p class="mb-0">{{ chutri.email }}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-6 col-12 justify-content-center">
                      <p class="mb-0 cs-bg-text"><span class="">{{ chutri.donVi.ten }}</span></p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- Thành phần tham dự-->
          <div v-if="chiTietCongViec.thanhPhanThamDu" class="row mb-3">
            <div>
              <h5 class="text-bold text-black">Thành phần tham dự</h5>
            </div>
            <div v-if="chiTietCongViec.thanhPhanThamDu">
              <div v-for="(tptd, index) in chiTietCongViec.thanhPhanThamDu" :key="index" class="cs-row">
                <div class="row equal-height-row ">
                  <div class="col-md-6 col-12">
                    <div class="row equal-height-row">
                      <div class="col-3 justify-content-center">
                      <span v-if="tptd.avatar">
                      <b-img
                          :src=" url + `${tptd.avatar.fileId}`"
                          alt="Avatar"
                          class="rounded-circle header-profile-user"
                      >
                      </b-img>
                    </span>
                        <span v-else>
                      <img
                          class="rounded-circle header-profile-user"
                          src="@/assets/images/users/user-4.jpg"
                          alt="Avatar"
                      />
                    </span>
                      </div>
                      <div class="col-9 justify-content-center">
                        <p v-if="tptd.fullName" class="mb-0 text-black">{{ tptd.fullName }}</p>
                        <div v-if="tptd.email" class="d-flex align-items-center">
                          <i class="mdi mdi-email text-warning me-1"></i>
                          <p class="mb-0">{{ tptd.email }}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6 col-12 justify-content-center">
                    <p class="mb-0 cs-bg-text">
                      <span class="">{{ tptd.donVi.ten }}</span>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>
<style>
.title-capso{
  font-weight: bold; color: #00568C;

}

.card-lichcongtac .card-body{
  padding: 0px;
}

/*@media only screen and (max-width: 768px){*/

/*  !* Force table to not be like tables anymore *!*/
/*  table, thead, tbody, th, td, tr {*/
/*    display: block;*/
/*    padding: 5px 0px !important;*/
/*  }*/

/*  !* Hide table headers (but not display: none;, for accessibility) *!*/
/*  thead tr {*/
/*    position: absolute;*/
/*    top: -9999px;*/
/*    left: -9999px;*/
/*  }*/

/*  tr { border: 1px solid #f5f5f5;*/
/*    margin-bottom: 5px;*/
/*  }*/

/*  .table-bordered > :not(caption) > * {*/
/*    border-width: 0.5px;*/
/*    border-radius: 5px;*/
/*  }*/

/*  .table-bordered{*/
/*    border: none;*/
/*  }*/

/*  .table-bordered th:first-child, .table-bordered td:first-child{*/
/*    border-top: none;*/
/*  }*/

/*  .table-bordered th, .table-bordered td{*/
/*    border: none;*/
/*    border-top: 1px solid #f5f5f5;*/
/*  }*/

/*  td {*/
/*    !* Behave  like a "row" *!*/
/*    border: none;*/
/*    border-bottom: 1px solid #eee;*/
/*    position: relative;*/
/*    min-height: 30px !important;*/
/*    padding-left: 20% !important;*/
/*    padding: 5px 0px;*/
/*  }*/

/*  td:before {*/
/*    !* Now like a table header *!*/
/*    position: absolute;*/
/*    !* Top/left values mimic padding *!*/
/*    top: 5px;*/
/*    left: 6px;*/
/*    padding-right: 10px;*/
/*    white-space: nowrap;*/
/*  }*/

/*  .btn-process {*/
/*    padding: 0px !important;*/
/*  }*/

/*  .btn-process .btn {*/
/*    background-color: rgb(0 89 144 / 0.1);*/
/*    width: 20%;*/
/*    margin: 5px;*/
/*  }*/

/*  !**/
/*  Label the data*/
/*  *!*/
/*  td:nth-of-type(1):before { content: "STT"; font-weight: bold; }*/
/*  td:nth-of-type(2):before { content: "Ngày"; font-weight: bold; }*/
/*  td:nth-of-type(3):before { content: "Thời gian"; font-weight: bold; }*/
/*  td:nth-of-type(4):before { content: "Nội dung"; font-weight: bold; }*/
/*  td:nth-of-type(5):before { content: "Địa điểm"; font-weight: bold; }*/
/*  td:nth-of-type(6):before { content: "Thành phần"; font-weight: bold; }*/
/*  td:nth-of-type(7):before { content: "Ghi chú"; font-weight: bold; }*/
/*  td:nth-of-type(8):before { content: ""; font-weight: bold; }*/
/*}*/

/*@media only screen and (max-width: 425px){*/
/*  td{*/
/*    padding-left: 25% !important;*/
/*  }*/
/*}*/

/*@media only screen and (max-width: 375px){*/
/*  td{*/
/*    padding-left: 30% !important;*/
/*  }*/
/*}*/

/*@media only screen and (max-width: 320px){*/
/*  td{*/
/*    padding-left: 35% !important;*/
/*  }*/
/*}*/
.multiselect{
  min-height: 34px;
}
.multiselect__select{
  height: 34px;
}
</style>
